import axios from 'axios';

import { SET_BUSINESS_GROUP, SET_WEBCHAT_LOCATIONS, SET_USERS } from './types';

export const getBusinessGroup = () => async (dispatch) => {
	try {
		const res = await axios.get('/api/business-group');

		const { businessGroup, users, webchatLocations } = res.data;

		if (businessGroup) {
			dispatch({
				type: SET_BUSINESS_GROUP,
				payload: businessGroup,
			});
		}

		if (users) {
			dispatch({
				type: SET_USERS,
				payload: users,
			});
		}

		if (webchatLocations) {
			dispatch({
				type: SET_WEBCHAT_LOCATIONS,
				payload: webchatLocations,
			});
		}
	} catch (err) {
		console.log('Error fetching business group', err);
		dispatch({ type: SET_BUSINESS_GROUP, payload: [] });
	}
};

export const setBusinessGroup =
	({ businessGroup }) =>
	async (dispatch, getState) => {
		try {
			if (businessGroup) {
				dispatch({
					type: SET_BUSINESS_GROUP,
					payload: businessGroup,
				});
			}
		} catch (err) {
			// if there is an error, check if the business group is already set
			const businessGroup = getState().businessGroup;

			if (businessGroup && businessGroup.length > 0) {
				return;
			}

			console.log('Error fetching business group', err);
			dispatch({ type: SET_BUSINESS_GROUP, payload: [] });
		}
	};

export const setWebchatLocations =
	({ webchatLocations }) =>
	async (dispatch) => {
		try {
			if (webchatLocations) {
				dispatch({
					type: SET_WEBCHAT_LOCATIONS,
					payload: webchatLocations,
				});
			}
		} catch (err) {
			console.log('Error fetching webchat locations', err);
			dispatch({ type: SET_WEBCHAT_LOCATIONS, payload: [] });
		}
	};
